import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
    Route,
    RouterProvider,
} from "react-router-dom";
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { AuthProvider, useAuth } from 'react-oidc-context';
import App from './App.jsx';
import Root from './Root.jsx';
import ProtectedRoute from './ProtectedRoute.tsx';
import reportWebVitals from './reportWebVitals';

const userManager = new UserManager({
    authority: `https://accounts.${process.env.REACT_APP_DOMAIN}/realms/farmblocks/`,
    client_id: "web-client",
    redirect_uri: `${window.location.origin}/main`,
    post_logout_redirect_uri: `${window.location.origin}/logout-success`,
    scope: 'openid profile email offline_access',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
});

userManager.clearStaleState().catch((error) => {
    console.error("failed to clear stale oidc state", error);
});

const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

const onSignoutCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

const matchSignoutCallback = () => {
  return window.location.pathname === '/logout-success';
};

function LoggedOut() {
    const auth = useAuth();
    return (
        <>
            <h1>Logged out</h1>
            <div>You have been signed out.</div>
            <button onClick={() => auth.signinRedirect()}>Log in</button>
        </>
    );
}

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<AuthProvider userManager={userManager} onSigninCallback={onSigninCallback} onSignoutCallback={onSignoutCallback} matchSignoutCallback={matchSignoutCallback}> <Root /> </AuthProvider>}>
            <Route path="/" element={<Navigate to="/main" />} errorElement={<div />} />
            <Route path="/logout-success" element={<LoggedOut />} />
            <Route element={<ProtectedRoute/> }>
                <Route path="/main" element={<App />} />
            </Route>
        </Route>
    )
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
        <RouterProvider router={router} />
);
// root.render(
//     <React.StrictMode>
//         <RouterProvider router={router} />
//     </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (e.g. reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
